import { BaseLandscapeService } from '../../base-landscape.service';
import { LocationResponseDto } from '../dto/response/location-response.dto';
import { LocationSaveRequestDto } from '../dto/request/location-save-request.dto';
import { LocationUpdateRequestDto } from '../dto/request/location-update-request.dto';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class LocationService extends BaseLandscapeService {
  public async fetchLocationById(id: string): Promise<LocationResponseDto> {
    const response = await this.get<LocationResponseDto>(`/location/${id}`);
    return response.data;
  }

  public async saveLocation(
    saveRequest: LocationSaveRequestDto
  ): Promise<LocationResponseDto> {
    const response = await this.post<LocationResponseDto>(
      `/location`,
      saveRequest
    );
    return response.data;
  }

  public async updateLocation(
    updateRequest: LocationUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<LocationResponseDto> {
    const response = await this.put<LocationResponseDto>(
      `/location`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteLocation(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/location/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const locationService = new LocationService();
export default locationService;
